import { Injectable } from '@angular/core'
import { Observable, switchMap, throwError } from 'rxjs'
import { selectCaseId, selectCaseMarkers } from '../../state/case/case.selectors'
import { StoreUtilsService } from './store-utils.service'
import { CaseId, MarkerDimension } from '../../state/case/case.state'

@Injectable({
    providedIn: 'root',
})
export class CaseUtilsService {
    constructor(private readonly storeUtils: StoreUtilsService) {}

    createObservableWithCaseId<T>(observableFn: (caseId: CaseId) => Observable<T>): Observable<T> {
        return this.storeUtils.snapshotObservable(selectCaseId).pipe(
            switchMap(caseId => {
                return caseId
                    ? observableFn(caseId)
                    : throwError(() => new Error('Could not determine dataset ID.'))
            })
        )
    }

    createObservableWithMarkerDimensions<T>(
        observableFn: (markerDimensions: MarkerDimension[]) => Observable<T>
    ): Observable<T> {
        return this.storeUtils.snapshotObservable(selectCaseMarkers).pipe(
            switchMap(markerDimensions => {
                return observableFn(markerDimensions)
            })
        )
    }
}
